<template>
  <v-container id="regular-tables" fluid tag="section" style="font-size:10px">
    <base-material-card color="#ed3325" icon="mdi-clipboard-text" title="Listado rutas" class="px-5 py-3">

      <!-- Botón global para subir complemento -->
      <v-btn color="primary" class="mb-4" @click="openDialog">
        Subir Complemento de Pago
      </v-btn>

      <v-data-table
        :items="solicitudes"
        :loading="loading"
        item-value="id"
        :headers="headers"
        show-expand
      >
        <template v-slot:item.total="{ item }">
          {{ Number(item.total || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ new Date(item.created_at).toLocaleDateString('es-MX') }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
                <v-card flat class="w-100">
                    <v-card-text>
                    <v-data-table
                        :items="item.solicitudes || []"
                        :headers="pagoHeaders"
                        dense
                        class="w-100"
                    >
                        <template v-slot:item.pivot.monto_aplicado="{ item }">
                        {{ Number(item.pivot.monto_aplicado || 0).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' }) }}
                        </template>
                    </v-data-table>
                    </v-card-text>
                </v-card>
            </td>
        </template>
      </v-data-table>

      <!-- Diálogo para subir XML + PDF -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>Subir Complemento de Pago</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-file-input
                v-model="archivoXML"
                label="Seleccionar XML"
                accept=".xml"
                required
              />
              <v-file-input
                v-model="archivoPDF"
                label="Seleccionar PDF"
                accept=".pdf"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">Cancelar</v-btn>
            <v-btn color="primary" :loading="loadingDialog" @click="saveComplemento">
              Subir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </base-material-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      solicitudes: [],
      loading: false,
      dialog: false,
      loadingDialog: false,
      archivoXML: null,
      archivoPDF: null,
      headers: [
        { text: 'ID', value: 'uuid' },
        { text: 'Monto', value: 'total' },
        { text: 'Estatus', value: 'estatus' },
        { text: 'Fecha', value: 'created_at' },
      ],
      pagoHeaders: [
        { text: 'Folio', value: 'folio' },
        { text: 'UUID', value: 'factura_xml.uuid' },
        { text: 'Monto Aplicado', value: 'pivot.monto_aplicado' },
      ],
    };
  },
  mounted() {
    this.getComplementos();
  },
  methods: {
    // Abrir diálogo global
    openDialog() {
      this.archivoXML = null;
      this.archivoPDF = null;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    getComplementos() {
      // Lógica para obtener complementos de pago
        this.loading = true;
        const id_proveedor = localStorage.getItem('proveedor_id');
        axios.get('/complemento?id_proveedor='+id_proveedor)
          .then(response => {
            this.solicitudes = response.data;
          })
          .catch(error => {
            //console.error('Error al obtener complementos de pago:', error);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    saveComplemento() {
      if (!this.archivoXML || !this.archivoPDF) {
        alert('Por favor, selecciona ambos archivos.');
        return;
      }
      this.loadingDialog = true;
      const formData = new FormData();
      const proveedorId = localStorage.getItem('proveedor_id');
      formData.append('xml', this.archivoXML);
      formData.append('pdf', this.archivoPDF);
      formData.append('id_proveedor', proveedorId);

      axios.post('/complemento/save', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          this.getComplementos();
          this.closeDialog();
        })
        .catch(error => {
          //console.error('Error al subir complemento de pago:', error);
          const { response } = error;

          const mensaje = response?.data?.message || 'Error al subir complemento de pago.';
          const errores = response?.data?.errors || [];

          // Construir lista en HTML si hay errores
          const listaErrores = errores.length
            ? `<ul style="text-align: left;">${errores.map(e => `<li>${e}</li>`).join('')}</ul>`
            : '';

          Swal.fire({
            icon: 'error',
            title: 'Mensaje',
            html: `${mensaje}${listaErrores}`,
          });
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
  },
};
</script>
